import { useState, useLayoutEffect, useCallback } from 'react'

export const useScrollThreshold = (threshold: number) => {
  const [isAboveThreshold, setIsAboveThreshold] = useState(false)

  const handleScroll = useCallback(() => {
    const shouldBeAbove = window.scrollY > threshold
    setIsAboveThreshold(prev => (prev !== shouldBeAbove ? shouldBeAbove : prev))
  }, [threshold])

  useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [handleScroll])

  return isAboveThreshold
}
